import { Widget } from "./Widget";
import { nanoid } from "nanoid";
import {useChat} from "../contexts/ChatProvider";

export const WidgetContainer = () => {

  const {messages, sendMessage, makeApiCall, setShowTypingIndicator} = useChat();

  const handleSend = (message) => {
    setShowTypingIndicator(true);
    const newMessages = [
      {
        _id: nanoid(),
        text: message,
        user: "me",
        type: "outgoing",
        createdAt: new Date(),
      },
    ];
    sendMessage(newMessages);
    makeApiCall(message).then(() => {
      setShowTypingIndicator(false);
    }).catch(err => {
      // console.log(err);
      sendMessage(      {
        _id: nanoid(),
        text: "Error sending message, please try again",
        user: "me",
        type: "incoming",
        createdAt: new Date(),
      });
      setShowTypingIndicator(false);
    });
  };
  return <Widget onSend={handleSend}/>

};
